import {
	EmailInteractionCard,
	GenericInteractionCard,
	VoiceInteractionCard,
	VoiceSimultaneousCard,
} from ".";
import { VoiceUnifyInteractionCard } from "./toaster/VoiceUnifyInteractionCard";
import { WebchatInteractionCard } from "./toaster/WebchatInteractionCard";
import { WhatsAppInteractionCard } from "./toaster/WhatsAppInteractionCard";

export const InteractionCard = () => {
	return (
		<>
			<VoiceInteractionCard />
			<VoiceUnifyInteractionCard />
			<GenericInteractionCard />
			<VoiceSimultaneousCard />
			<EmailInteractionCard />
			<WhatsAppInteractionCard />
			<WebchatInteractionCard />
		</>
	);
};
